import React, { useState, useEffect } from "react";
import axios from "axios";
import qscoinprice from "../../data/qscoinprice";
import {DiscountBanner} from "../compIndex";

const VipComp = () => {
  const vipNames = {
    itm_vipcoupon_1month: "1-Month VIP",
    itm_vipcoupon_notrade: "3-Months VIP",
    itm_vipcoupon_6month_notrade: "6-Months VIP",
    itm_vipcoupon_12month: "12-Months VIP",
  };

  const [vipprices, setvipPrices] = useState([]);
  const [coinprices, setcoinPrices] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const priceResponse = await axios.get("https://api.pixelore.wiki/api/prices");
        const data = priceResponse.data;
        const vipItems = [];

        for (const key in data) {
          const item = data[key];
          if (item.uid.startsWith("itm_vip") && item.uid !== "itm_vipcoupon" && item.uid !== "itm_vipcoupon_6month") {
            vipItems.push(item);
          }
        }

        setvipPrices(vipItems);
      } catch (error) {
        console.log("Issue fetching data: ", error);
      }

      try {
        const coins = [];

        for (const key in qscoinprice) {
          const item = qscoinprice[key];
          if (item.itemid.startsWith("itm_coin")) {
            coins.push(item);
          }
        }

        setcoinPrices(coins);
      } catch (error) {
        console.log("Issue setting coin and QS prices: ", error);
      }
    };

    fetchData();
  }, []);

 return (
    <div className="px-2 md:px-4">
      <h1 className="home-title">VIP Prices</h1>
      {/* Horizontal scroll container for mobile */}
      <div className="flex md:flex-wrap overflow-x-auto md:overflow-x-visible gap-3 md:gap-4 pb-4 -mx-2 px-2 md:justify-center md:px-0">
        {[...vipprices].sort((a, b) => a.buyPrice - b.buyPrice).map((price) => (
          <div
            key={price.uid}
            className="flex-shrink-0 w-64 md:w-56 bg-[var(--entity-bg-color)] text-[var(--font-color)] p-3 md:p-4 border-solid border-2 border-[var(--button2-bg-color)] rounded-md hover:bg-[var(--entity-hover-bg-color)]"
          >
            <img
              src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/i/itm_vipcoupon_1month/37735029-fd7f-4b6f-81e6-f691e763fc1c.png"
              alt="vip"
              className="h-10 md:h-12 mx-auto mb-2"
            />
            <div className="font-bold text-center text-sm md:text-base mb-2">
              {vipNames[price.uid] || price.uid}
            </div>
            
            {/* Price row */}
            <div className="flex items-center justify-center mb-1">
              <img
                src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/currency/pixels_pixel_currency_new_2.png"
                className="h-5 md:h-6 mr-1"
                alt="pixel"
              />
              <span className="text-sm">{price.buyPrice.toLocaleString()}</span>
            </div>
            
            {/* Coin price row */}
            <div className="flex items-center justify-center mb-2">
              <img 
                src="https://d31ss916pli4td.cloudfront.net/game/ui/coin.png" 
                className="h-5 md:h-6 mr-1" 
                alt="coins" 
              />
              <span className="text-sm">
                {Math.round(price.buyPrice * (coinprices[0]?.amount / coinprices[0]?.price)).toLocaleString()}
              </span>
            </div>
            
            {/* Discount section */}
            <div className="bg-[var(--panel-bg-color)] rounded p-2 text-xs">
              <div className="flex justify-center items-center mb-1">
                <span className="mr-1">Less 5%:</span>
                <img
                  src="https://d31ss916pli4td.cloudfront.net/uploadedAssets/currency/pixels_pixel_currency_new_2.png"
                  className="h-3 mr-1"
                  alt="pixel"
                />
                <span>{(price.buyPrice * 0.95).toLocaleString()}</span>
              </div>
              <div className="flex justify-center items-center">
                <img 
                  src="https://d31ss916pli4td.cloudfront.net/game/ui/coin.png" 
                  className="h-3 mr-1" 
                  alt="coins" 
                />
                <span>
                  {Math.round((price.buyPrice * 0.95) * (coinprices[0]?.amount / coinprices[0]?.price)).toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        ))}
      </div>
      
      <DiscountBanner />
    </div>
  );
};

export default VipComp;
